import React from "react";

import "./style.css";

export default function CustomSwitch({
  containerClasses = "",
  containerStyles = {},
  switchClasses = "",
  checked = false,
  onChange = function() {}
}) {
  let isChecked = checked;

  const handleChange = e => {
    isChecked = e.target.checked;
    onChange(e.target.checked);
  };

  return (
    <div
      className={`custom-switch-container ${containerClasses}`}
      style={containerStyles}
    >
      <label style={{ lineHeight: 1, fontWeight: "bold" }}>Remember me</label>
      <label className="custom-switch">
        <input onChange={handleChange} type="checkbox" checked={isChecked} />
        <span className="custom-switch-slider round" />
      </label>
    </div>
  );
}
